import React from 'react'

import Icon from './components/Icon'

const IconHome = (props: IconProps) => {
  return <Icon {...props} id="nav-home" handle="homeIcon" />
}

export default IconHome
